import { useMutation, useQueryClient } from 'react-query';
import { successToast } from 'lib/components/toasts/success';
import { errorToast } from 'lib/components/toasts/error';
import { EXPRESS_API } from 'configs/api/expressApi';
import { uiKitsKeys } from './uiKitsKeys';
import { IUIKitsQueryParams } from './useQueryUIKits';

export const deleteUIKit = async (id: number) => {
  const response = await EXPRESS_API.delete(`/superadmin/uikit/${id}`);
  return response.data;
};

interface IUIKitDeleteMutationParams {
  closeModalHandler: () => void;
  params: IUIKitsQueryParams;
}

export const useDeleteUIKitMutation = ({
  closeModalHandler,
  params,
}: IUIKitDeleteMutationParams) => {
  const queryClient = useQueryClient();
  return useMutation(deleteUIKit, {
    onSuccess: async () => {
      await queryClient.refetchQueries(uiKitsKeys.list(params));
      successToast({
        title: 'UI Kit has been successfully deleted!',
      });
      closeModalHandler();
    },
    onError: () => {
      errorToast({
        title:
          'An error occurred when attempting to delete the UI Kit. Please try again later.',
      });
    },
  });
};
